module.exports = __webpack_public_path__ + "assets/GoogleSans-Regular.210e78940a985587ea769b9031e4d7c7.woff";